import { speed } from 'src/ui/common/config/animations';
import styled from 'styled-components';

export const StyledSpan = styled.span`
    pointer-events: none;
    position: relative;
    display: block;
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 1px solid var(--grey-600, #49504d);

    &:after,
    &:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 1px;
        bottom: 0;
        margin: auto;
        display: inline-block;
        background-color: ${({ theme }) => `${theme.colors.black}`};
        width: 1.5px;
        border-radius: 1px;
        opacity: 0;
        transition: opacity ${speed.input};
    }

    &:after {
        transform: rotate(-40deg);
        height: 5px;
        left: -4px;
        top: 3px;
    }

    &:before {
        transform: rotate(40deg);
        height: 8px;
        right: -3px;
    }
`;

export const StyledWrapper = styled.label`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 20px;
    cursor: pointer;
    width: 24px;
    height: 24px;
`;

export const StyledInput = styled.input`
    display: none;

    &:hover:not(:checked) + ${StyledSpan} {
        box-shadow: none;
    }

    &:checked + ${StyledSpan} {
        position: relative;
        background: ${({ theme }) => theme.colors.grey200};

        &:after,
        &:before {
            opacity: 1;
        }
    }
`;